<template>
<div class="back-header">
    <v-toolbar dense app flat scroll-off-screen :color="bgColor">
        <v-btn icon small flat v-if="route" :to="route">
            <v-icon>arrow_back</v-icon>
        </v-btn>
        <v-toolbar-title class="subheading">{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <slot></slot>
    </v-toolbar>
</div>
</template>

<script>
export default {
    props: {
        title: String,
        route: {
            type: String,
            default: ''
        },
        bgColor: {
            type: String,
            default: 'white'
        }
    }
}
</script>

<style lang="scss">
.back-header {
    .v-toolbar {
        border-bottom: 1px solid rgba(#000, .1) !important;
    }
}

.fz-14
{
    font-size: 14px;
}
</style>
